import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { gossipCategories, gossipList } from "@/mocks/gossipList";
import GossipCard from "@/components/base/GossipCard";

const HOME_LIMIT = 6;

export default function DigestSection() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(() => {
    const list = active === "全部" ? gossipList : gossipList.filter((g) => g.category === active);
    return [...list].sort((a, b) => a.rank - b.rank);
  }, [active]);

  const shown = filtered.slice(0, HOME_LIMIT);

  return (
    <section id="digest" className="w-full bg-background-50" aria-labelledby="digest-title">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-3xl mb-8">
          <p className="flex items-center gap-2 text-xs text-accent-700 mb-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-list-check-2"></i>
            </span>
            THE 30 LIST
          </p>
          <h2 id="digest-title" className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
            30 个瓜大盘点
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            每一条都标注了核心人物、冲突点与当前状态，点进详情可以看到完整的事件脉络时间线。
            先按分类挑一类看，也可以直接翻完整榜单。
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-8" role="tablist" aria-label="按主题分类筛选">
          {gossipCategories.map((c) => {
            const isActive = active === c.key;
            return (
              <button
                key={c.key}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(c.key)}
                className={`flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm whitespace-nowrap border transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-500 text-background-50 border-primary-500"
                    : "bg-background-100 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={c.icon}></i>
                </span>
                {c.label}
              </button>
            );
          })}
        </div>

        {shown.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {shown.map((item) => (
              <GossipCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className="bg-background-100 border border-background-200 rounded-lg py-16 text-center">
            <p className="text-foreground-600 text-sm">该分类暂时还没有整理好的条目，换个分类看看吧。</p>
          </div>
        )}

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-background-100 border border-background-200 rounded-lg p-5 md:p-6">
          <p className="text-sm text-foreground-700 text-center sm:text-left">
            当前分类共 <strong className="text-primary-600">{filtered.length}</strong> 条，
            榜单完整收录 30 条，含事件脉络与相关推荐。
          </p>
          <Link
            to={active === "全部" ? "/rankings" : `/rankings?category=${encodeURIComponent(active)}`}
            className="px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            查看该分类全部条目
          </Link>
        </div>
      </div>
    </section>
  );
}